<template>
  <div class="zhongyi-nagahome">
    <div class="zhongyi-box">
      <div class="zhongyi-left">
        <div class="nagahome-logo"
             @click="toUrl('/')">
          <img style="height: 64px"
               src="/static/images/toubu.png?v=1.0"
               alt="">
        </div>
        <div class="nagahome-link">
          <template v-for="(item,index) in menu_list">
            <!--<router-link :to="item.urls">-->
            <div class="link-text"
                 @click="show_ctrl(index,item.urls)"
                 :class="{'active_text':index===isActive}">
              {{item.name}}
            </div>
            <!--</router-link>-->
          </template>
        </div>
      </div>
      <div class="zhongyi-right">
        <div class="right-link"
             @click="signIn(1)"
             v-show="!$store.state.app.data">
          登录
        </div>

        <div class="personl-msg"
             v-if="$store.state.app.data">
          <div class="headimg"
               @click="toUrl('/personal/index')"
               v-if="$store.state.app.data && $store.state.app.data.headimg"
               :style="{'background-image':'url(' + $store.state.app.data.headimg + ')'}">
            <div class="msg-num"
                 v-if="$store.state.app.nunm>0">{{$store.state.app.nunm}}</div>
            <div class="sanjiao-hover"></div>
          </div>
          <div style="cursor: pointer;"
               @click="toUrl('/personal/index')">{{$store.state.app.data.username}}</div>
          <div class="personl-list">
            <div class="new_add">
              <div class="personl-text"
                   @click="toUrl('/personal/index',{type:1})">
                <img src="/static/images/shoucang.png" /><span>我的收藏</span>
              </div>
              <div class="personl-text"
                   @click="toUrl('/personal/index',{type:2})">
                <img src="/static/images/jifen.png" /><span>积分纪录</span>
              </div>
              <div class="personl-text"
                   @click="toUrl('/personal/index',{type:3})">
                <img src="/static/images/xiaoxi.png" /><span>消息中心</span> <span class="xiaoxi"
                      v-if="msg_num>0">{{msg_num}}</span>
              </div>
              <div class="personl-text"
                   @click="signOut">
                <img src="/static/images/xinix.png" /><span>退出登录</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right-link"
             @click="signIn(2)"
             v-show="!$store.state.app.data">
          注册
        </div>
        <div class="right-link"
             @click="gomyCulum">
          <span>我的课程</span>

        </div>
        <div class="right-down">
          <!-- <div class="down-img">
            <img src="/static/images/shouji.png" />
          </div> -->
          <div class="down-text">
            下载学习时代APP
          </div>
          <div class="down-qrdoe">
            <!--<div v-html="donw_url"></div>-->
            <img :src="donw_url" />
            <!--{{$store.state.app.donw_url.qr_code}}-->
            <!--<img src="https://s3m.mediav.com/galileo/471609-63620aeadbd0c739fc1fc90592520c67.jpg"/>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      msg_num: 0,
      res_login: tools.cache.get('status') ? true : false,
      menu_list: [{
        name: "课程",
        urls: "/",
      },
      {
        name: "公开课",
        // urls: "/open/index",
        urls:'/line/linelist'
      },
      //element : 1.2.8
      {
        name: "练习",
        urls: "/practice/index",
      },
      {
        name: "资讯",
        urls: "/realtime/realtime",
      }
      ],
      donw_url: ''
    }
  },
  methods: {
    goTo () {
      let that = this;
      that.is_login(function () {
        that.toUrl('/personal/index', { type: 3 })
      })

    },
    gomyCulum () {
      let that = this;
      if (JSON.parse(tools.cache.get('status'))) {
        that.toUrl('/personal/culum')
      } else {
        this.$store.state.app.dialogVisible = true;
        this.$store.state.app.sin_login = true
      }
    },
    /*是否登录*/
    is_login (callback) {
      let that = this,
        ajaxData = {};
      tools.alert.loading();
      tools.ajax({
        url: '/api/status',
        ajaxData: ajaxData,
        successFun: function (res) {
          tools.alert.closeLoading();
          if (res.data.is_user == 0) {
            that.$store.state.app.dialogVisible = true;
            that.$store.state.app.sin_login = true;
            return
          } else {
            callback()
          }

        },
        errorFun: function (error_data, status, headers, error_obj) {
          tools.alert.closeLoading();
          tools.alert.error(error_data.error_msg);
        },
        type: 'GET'
      })
    },
    doWnload () {
      let that = this,
        ajaxData = {};
      tools.alert.loading();
      tools.ajax({
        url: '/api/download/app',
        ajaxData: ajaxData,
        successFun: function (res) {
          that.donw_url = res.data.qr_code
          tools.alert.closeLoading();
        },
        errorFun: function (error_data, status, headers, error_obj) {
          tools.alert.closeLoading();
          tools.alert.error(error_data.error_msg);
        },
        type: 'GET'
      });
    },
    signIn (val) {
      this.$store.state.app.dialogVisible = true;
      if (val == 1) {
        this.$store.state.app.sin_login = true
      } else {
        this.$store.state.app.register = true
      }


    },
    show_ctrl (index, Url) {
      if (Url == '/practice/index') {
        if (!tools.cache.get('status')) {
          this.$store.state.app.dialogVisible = true;
          this.$store.state.app.sin_login = true;
          return;
        }
      }
      this.toUrl(Url)
      this.$emit('clicfun', index)
    },
    /*退出登录*/
    signOut () {
      let that = this,
        ajaxData = {};
      tools.alert.loading();
      tools.ajax({
        url: '/api/logins',
        ajaxData: ajaxData,
        successFun: function (res) {
          tools.cache.del('status');
          tools.cache.del('time');
          tools.cache.del('Authorization');
          setTimeout(function () {
            that.toUrl('/');
            that.$store.commit('GET_INFO')
          }, 20)

          tools.alert.closeLoading();
        },
        errorFun: function (error_data, status, headers, error_obj) {
          tools.alert.closeLoading();
          tools.alert.error(error_data.error_msg);
        },
        type: 'DELETE'
      })
    },
    /*消息未读数量*/
    msgNum () {
      let that = this,
        ajaxData = {};
      if (!JSON.parse(tools.cache.get('status'))) {
        return
      }
      that.$store.commit('GET_LIST')
      // tools.alert.loading();
      // tools.ajax({
      // 	url: '/api/user/messages/unread/num',
      // 	ajaxData: ajaxData,
      // 	successFun: function(res) {
      // 		that.msg_num = res.data.num;
      // 		tools.alert.closeLoading();
      // 	},
      // 	errorFun: function(error_data, status, headers, error_obj) {
      // 		tools.alert.closeLoading();
      // 		tools.alert.error(error_data.error_msg);
      // 	},
      // 	type: 'GET'
      // })
    }
  },
  props: {
    isActive: {
      type: Number,
      default: 0
    },
  },
  watch: {

  },
  components: {

  },
  filters: {

  },
  mounted () {
    this.$store.commit('GET_INFO')
    this.doWnload();
    if (tools.cache.get('status')) {
      this.msgNum();
    }

  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.zhongyi-nagahome {
  width: 100%;
  height: 70px;
  position: relative;
  z-index: 1111;
  // border-style: solid;
  // border-width: 1px;
  // border-color: rgb(229, 229, 229);
  background-color: #303440;
  opacity: 0.93;
  .zhongyi-box {
    width: 1200px;
    height: 70px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #303440;
    .zhongyi-left {
      display: flex;
      align-items: center;
      .nagahome-logo {
        cursor: pointer;
        height: 67px;
        overflow: hidden;
        .img {
          width: 41px;
        }
        .img-zimu {
          display: inline-block;
          margin-left: 8px;
          height: 30px;
        }
      }
      .nagahome-link {
        display: flex;
        align-items: center;
        margin-left: 56px;
        a {
          text-decoration: none;
        }
        .link-text {
          cursor: pointer;
          display: flex;
          align-content: center;
          align-items: center;
          justify-content: center;
          color: #c3c3c3;
          width: 110px;
          height: 40px;
          border-radius: 5px;
          font-size: 16px;
          opacity: 0.8;
          &:hover {
            color: #ffffff;
            // background-color: rgb(92, 131, 252);
            opacity: 1;
          }
        }
        .active_text {
          color: #ffffff;
          opacity: 1;
          // background-color: rgb(92, 131, 252);
        }
      }
    }
    .zhongyi-right {
      display: flex;
      align-content: center;
      align-items: center;
      .right-link {
        position: relative;
        padding-left: 16px;
        padding-right: 16px;
        font-size: 14px;
        color: #fff;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        // border-left: 1px solid #cbcbcb;
        // border-right: 1px solid #cbcbcb;
        opacity: 0.6;
        &:hover {
          // color: #5c83fc;
          opacity: 1;
        }
        &:nth-of-type(3) {
          // border-right: 1px solid #cbcbcb;
        }
        .set-msg {
          position: absolute;
          top: -11px;
          left: 39px;
          border-radius: 10px;
          color: #fff;
          display: inline-block;
          font-size: 12px;
          height: 19px;
          line-height: 19px;
          padding: 0 6px;
          text-align: center;
          white-space: nowrap;
          background: #db251c;
        }
      }
      .personl-msg {
        padding: 0 17px;
        border-left: 1px solid #898989;
        margin-left: 18px;
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        color: #898989;
        position: relative;
        height: 14px;
        .headimg {
          width: 26px;
          height: 26px;
          margin-right: 16px;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          position: relative;
          .msg-num {
            text-align: center;
            width: 16px;
            height: 14px;
            border-radius: 5px;
            position: absolute;
            right: -3px;
            top: -6px;
            background-color: rgb(241, 96, 96);
            font-size: 10px;
            color: #ffffff;
          }
          .sanjiao-hover {
            position: absolute;
            right: -8px;
            bottom: -5px;
            width: 5px;
            height: 5px;
            background: url(/static/images/sanjiao.png);
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          }
        }
        &:hover {
          .personl-list {
            display: block;
          }
        }
        .personl-list {
          display: none;
          position: absolute;
          top: 16px;
          left: -128px;
          width: 269px;
          height: 200px;
          padding-top: 17px;
          .new_add {
            width: 180px;
            height: 176px;
            padding-top: 7px;
            padding-bottom: 7px;
            background: #ffffff;
            box-shadow: 0px 0px 7px 0px rgba(142, 142, 142, 0.157);
          }
          .personl-text {
            width: 100%;
            height: 40px;
            font-size: 14px;
            color: #464646;
            padding-left: 25px;
            display: flex;
            align-items: center;
            margin: 0 auto;
            cursor: pointer;
            position: relative;
            .xiaoxi {
              text-align: center;
              position: absolute;
              right: 12px;
              width: 16px;
              height: 14px;
              border-radius: 5px;
              background-color: rgb(241, 96, 96);
              font-size: 10px;
              color: #ffffff;
            }
            span {
              display: inline-block;
              margin-left: 10px;
            }
            &:hover {
              background: #f5f5f5;
            }
          }
        }
      }

      .right-down {
        // margin-left: 17px;
        display: flex;
        align-items: center;
        position: relative;
        &:hover {
          .down-qrdoe {
            display: block;
          }
        }
        .down-img {
          width: 16px;
          height: 25px;
        }
        .down-text {
          margin-left: 13px;
          font-size: 14px;
          color: #808080;
        }
        .down-qrdoe {
          position: absolute;
          top: 19px;
          left: 50%;
          transform: translateX(-50%);
          width: 128px;
          height: 128px;
          line-height: 128px;
          background: url(/static/images/erweima.png);
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
          display: table-cell;
          vertical-align: middle;
          text-align: center;
          display: none;
          img {
            width: 67px;
            height: 67px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Navigahome.vue?9be56d72